import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { Reveal, MaskLineInView } from "./Reveal";
import { selectPaket } from "./Pricing";
import { scrollToId as scrollTo } from "@/lib/scroll";

const PLANS = [
  { name: "Basic", price: "49 €", total: "588 € gesamt in 12 Monaten", highlight: false },
  { name: "Business", price: "79 €", total: "948 € gesamt in 12 Monaten", highlight: true },
  { name: "Premium", price: "99 €", total: "1.188 € gesamt in 12 Monaten", highlight: false },
];

export default function FinalCta() {
  return (
    <section className="relative py-16 lg:py-24 border-t border-white/10" data-testid="final-cta">
      <div className="mx-auto max-w-[1400px] px-6 lg:px-10">
        <div className="max-w-3xl mb-12">
          <h2 className="font-display text-4xl md:text-6xl leading-[0.98] tracking-tight text-white uppercase mb-6">
            <MaskLineInView>Ihre Website sollte Ihnen</MaskLineInView>
            <MaskLineInView delay={0.1}>Arbeit abnehmen –</MaskLineInView>
            <MaskLineInView delay={0.2} className="text-[#FF3B00]">nicht neue machen.</MaskLineInView>
          </h2>
          <Reveal delay={0.15} className="text-neutral-300 text-base lg:text-lg leading-relaxed">
            Wir kümmern uns um Erstellung, Domain, Hosting und Technik. Und wenn sich in Ihrem
            Unternehmen etwas ändert, kümmern wir uns je nach Paket auch um Ihre Website.
          </Reveal>
        </div>

        <div className="grid sm:grid-cols-3 gap-4 mb-10">
          {PLANS.map((p, i) => (
            <motion.button
              key={p.name}
              onClick={() => selectPaket(`${p.name} – ${p.price}`)}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.08 }}
              className={`text-left border p-6 transition-colors duration-200 ${
                p.highlight ? "border-[#FF3B00] bg-[#FF3B00]/[0.05]" : "border-white/10 bg-[#100b07] hover:border-white/25"
              }`}
              data-testid={`final-plan-${p.name.toLowerCase()}`}
            >
              {p.highlight && <span className="font-tech text-[10px] uppercase tracking-[0.14em] text-[#FF3B00]">Beliebteste Wahl</span>}
              <div className="flex items-end gap-2 mt-1">
                <span className="font-display text-4xl text-white">{p.price}</span>
                <span className="text-neutral-500 text-sm mb-1">/ Monat</span>
              </div>
              <p className="font-display text-lg text-white mt-2">{p.name}</p>
              <p className="text-neutral-500 text-xs mt-1">{p.total}</p>
            </motion.button>
          ))}
        </div>

        <Reveal>
          <button
            onClick={() => scrollTo("#kontakt")}
            className="group w-full sm:w-auto inline-flex items-center justify-center gap-2 bg-[#FF3B00] text-white font-tech text-sm uppercase tracking-[0.12em] px-10 py-5 hover:bg-[#FF5C2B] active:scale-[0.99] transition-all duration-200"
            data-testid="final-cta-button"
          >
            Jetzt unverbindlich Website anfragen
            <ArrowUpRight size={18} className="group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
          </button>
          <p className="mt-6 font-tech text-xs uppercase tracking-[0.14em] text-neutral-500">
            Website · Domain · Hosting · Betreuung — alles aus einer Hand
          </p>
          <p className="mt-2 text-neutral-600 text-xs">
            Alle Preise brutto. 12 Monate Mindestlaufzeit – danach monatlich flexibel.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
